import i18n from '@/user/plugins/i18n'

/**
 * I18n Service
 * @class I18nInfo
 * @property {string} path 페이지단위 기본 경로
 */
export class I18nInfo {
  constructor(path) {
    this.path = path
  }

  /**
   * yaml parser
   * @param {string} path 기본 경로
   * @param {string} value 키워드
   * @param named
   * @returns {string}
   */
  perseYaml(path, value, named) {
    return i18n.global.t(`${path}.${value}`, named)
  }

  /**
   * 번역
   * @param {string} value 키워드
   * @param named
   * @returns {string} 국가별 번역
   */
  translate(value, named = undefined) {
    return this.perseYaml(this.path, value, named)
  }
}
